import isEmpty from './isEmpty'
import getAdjReason from './getAdjReason'
//-----------------
// get adj reasons
//-----------------
// array of combined adjs (chars + runes)
export default function getAdjReasons({ character, category, type }) {
  console.log('--------------------------')
  console.log('IN getAdjReasons')
  //---------------------------------
  // clear existing reasons for type
  //---------------------------------
  character[`${type}_adjs_reasons`] = ''
  //-----------------------------
  // grab adjs for category/type
  //-----------------------------
  const adjs = character[`${category}_adjs`].filter((c) => c.name == type)
  console.log(
    `1. Combined adjs for category ${category} and type ${type} = `,
    window.$deepCopy(adjs),
  )
  const seenReasons = new Set()
  //--------------------
  // loop combined adjs
  //--------------------
  adjs.forEach((a) => {
    console.log('-----------------------------------------')
    console.log('2. Processing adj = ', window.$deepCopy(a))
    //----------------------------------------------
    // build adj reasons (will be category + runes)
    //----------------------------------------------
    if (!isEmpty(a.adj_reason)) {
      let reason = getAdjReason(a.adj_reason, a.adj_value)
      if (seenReasons.has(reason)) {
        return
      }
      seenReasons.add(reason)
      console.log('3. Built reason = ', reason)
      //--------------------------------
      // append to character reasons
      //--------------------------------
      // first adj pass
      if (isEmpty(character[`${a.name}_adjs_reasons`])) {
        character[`${a.name}_adjs_reasons`] = reason
        console.log(`4. Set initial reason for ${a.name} = `, character[`${a.name}_adjs_reasons`])
      } else {
        // subsequent adj passes
        console.log(`5. Appending reason for ${a.name} = `, reason)
        character[`${a.name}_adjs_reasons`] += '. ' + reason
      }
    }
  })
  return character
}
